import { compose, createStore } from 'redux'

import createRootReducer from './rootReducer'

const configureStore = (preloadedState?: any) => {
  const composeEnhancer: typeof compose =
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const store = createStore(
    createRootReducer(),
    preloadedState,
    composeEnhancer(),
  )

  return store
}

export default configureStore
